import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { TipologiaImmagine } from "../../types"
import { Button } from "@inmagik/magik-ui"
import { initialValuesTipologiaImmagine, validationSchemaTipologiaImmagine } from "./TipologiaImmagineCommon"
import { useMemo } from "react"
import TipologiaImmagineForm from "./TipologiaImmagineForm"

export default function TipologiaImmagineModal({
  title,
  tipologiaImmagine,
  save,
  show,
  onClose,
}: {
  title: string
  tipologiaImmagine?: TipologiaImmagine
  save: (values: TipologiaImmagine, actions: { setErrors: (errors: any) => void }) => Promise<void>
  show: boolean
  onClose: () => void
}) {

  const initialValues = useMemo(() => initialValuesTipologiaImmagine(tipologiaImmagine) as TipologiaImmagine, [tipologiaImmagine])
  const validationSchema = useMemo(() => validationSchemaTipologiaImmagine(), [])

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={save}
    >
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} size="lg" backdrop="static">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <TipologiaImmagineForm col={12} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
